import styled from "styled-components";

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const FieldsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  column-gap: 2rem;
  width: 90%;

  // @media (max-width: 1300px) {
  //   width: 50rem;
  // }
`;

export const TextHeader = styled.div`
  color: rgb(42, 61, 163);
  font-weight: 500;
  padding: 0.5rem 0;
  font-size: 18px;
  // font-family: Poppins, sans-serif;
`;

export const MainTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  // padding: 0.5rem 0;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
`;

export const ButtonsContainer = styled.div`
  width: 90%;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
`;
